import { IConfig } from '@cian/config/shared';

const NEWBUILDING_BROKER_REWARD_TARIFFS = 'newbuilding-broker-reward-tariffs.rewardTariffsUrl';

export const getNewbuildingBrokerRewardTariffsUrl = (config: IConfig) =>
  config.getStrict<string>(NEWBUILDING_BROKER_REWARD_TARIFFS);
